function pricingParagraph() {
  $(document).ready(function () {
    const $switches = $('[data-billing-switch]');

    if (!$switches.length) {
      return;
    }

    $switches.each(function () {
      const $switch = $(this);
      const $buttons = $switch.find('[data-billing]');
      const $prices = $('.pricing-price');

      if ($switch.data('pricing-initialized')) {
        return;
      }
      $switch.data('pricing-initialized', true);

      $buttons.on('click', function () {
        const $btn = $(this);
        const mode = $btn.data('billing'); // monthly | yearly

        $buttons.removeClass('is-active');
        $btn.addClass('is-active');

        if (mode === 'yearly') {
          $prices.addClass('yearly');
        } else {
          $prices.removeClass('yearly');
        }

        $prices.each(function () {
          animatePrice($(this), mode);
        });
      });
    });
  });
}

/* ================= HELPERS ================= */

function animatePrice($price, mode) {
  const $amountEl = $price.find('.pricing-amount');
  const $periodEl = $price.find('.pricing-period');

  const from = parseFloat($amountEl.text());
  const to = parseFloat($price.data(mode));

  if (isNaN(from) || isNaN(to)) {
    return;
  }

  const periodText = mode === 'yearly'
    ? $price.data('period-yearly')
    : $price.data('period-monthly');

  $price.addClass('is-animating');

  setTimeout(function () {
    countUp(from, to, $amountEl, 300, mode);
    $periodEl.text('/ ' + periodText);
    $price.removeClass('is-animating');
  }, 200);
}

function countUp(from, to, $el, duration, mode) {
  const start = performance.now();
  const decimals = mode === 'yearly' ? 1 : 0;

  function tick(now) {
    const progress = Math.min((now - start) / duration, 1);
    const eased = easeOutCubic(progress);
    const rawValue = from + (to - from) * eased;

    const value = Number(rawValue.toFixed(decimals)).toString();
    $el.text(value);

    if (progress < 1) {
      requestAnimationFrame(tick);
    }
  }

  requestAnimationFrame(tick);
}

function easeOutCubic(t) {
  return 1 - Math.pow(1 - t, 3);
}
